module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l95Is"))).then(() => parcelRequire('fThBo'));